import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getEmployerBenefitPlan = ({ planId }) =>
  call(websocketFetch, 'get_employer_benefit_plan', {
    plan_id: planId,
  });
